import React, { useEffect, useRef } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { getMapOptions } from '../../../../../utils/helpers/getMapOptions';
import { InitCoordinatesType } from '../types';
import useScreenSize from '../../../../../hooks/useScreenSize';

interface MapProps {
  isModalOpen: boolean;
  coordinates: InitCoordinatesType;
  pinSelected: boolean;
  initialLocation: InitCoordinatesType;
  setCoordinates: React.Dispatch<
    React.SetStateAction<Exclude<InitCoordinatesType, undefined>>
  >;
}

export const Map: React.FC<MapProps> = ({
  isModalOpen,
  coordinates,
  initialLocation,
  setCoordinates,
  pinSelected
}) => {
  const mapRef = useRef<google.maps.Map | null>();
  const { isSmall } = useScreenSize();
  const { mapOptions, mapStyle } = getMapOptions(isModalOpen, isSmall);

  const onMapClick = (event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      const newPos = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      setCoordinates(newPos);
    }
  };

  useEffect(() => {
    if (mapRef.current && coordinates) {
      mapRef.current.panTo(coordinates);
    }
  }, [coordinates, mapRef.current]);

  return (
    <GoogleMap
      zoom={14}
      options={mapOptions}
      center={initialLocation}
      mapContainerStyle={mapStyle}
      onClick={isModalOpen ? onMapClick : null}
      onLoad={(map: google.maps.Map) => {
        mapRef.current = map;
      }}
    >
      {(pinSelected || isModalOpen) && coordinates && (
        <Marker
          draggable
          position={coordinates}
          onDragEnd={onMapClick}
          icon="../static/images/new_ad/icons/icon-map-pin.png"
        />
      )}
    </GoogleMap>
  );
};
